export default function KPIs() {
  const kpis = [
    {
      icon: 'ri-building-line',
      title: 'عدد الجهات المشاركة',
      target: '+50',
      description: 'جهة حكومية وخاصة وغير ربحية',
      color: 'from-[#1B5E20] to-[#2E7D32]'
    },
    {
      icon: 'ri-team-line',
      title: 'نسبة حضور الشباب',
      target: '75%',
      description: 'من إجمالي المشاركين',
      color: 'from-[#D4AF37] to-[#B8941F]'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'عدد التوصيات المعتمدة',
      target: '+30',
      description: 'توصية قابلة للتنفيذ',
      color: 'from-[#1B5E20] to-[#2E7D32]'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'رضا المشاركين',
      target: '90%',
      description: 'معدل الرضا المستهدف',
      color: 'from-[#D4AF37] to-[#B8941F]'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-3 bg-[#1B5E20]/10 px-6 py-3 rounded-full">
              <i className="ri-line-chart-line text-2xl text-[#1B5E20]"></i>
              <span className="text-sm font-bold text-[#1B5E20]">مؤشرات الأداء</span>
            </div>
          </div>
          <h2 className="text-5xl font-bold text-[#1B5E20] mb-6">
            مؤشرات قياس النجاح
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            نقيس نجاح الملتقى من خلال مؤشرات أداء رئيسية تضمن تحقيق الأهداف الاستراتيجية
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {kpis.map((kpi, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${kpi.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-300`}></div>
              
              <div className="relative">
                <div className={`w-16 h-16 bg-gradient-to-br ${kpi.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${kpi.icon} text-3xl text-white`}></i>
                </div>

                <h3 className="text-lg font-bold text-gray-800 mb-4 leading-relaxed">
                  {kpi.title}
                </h3>

                <div className="text-5xl font-bold text-[#1B5E20] mb-3">
                  {kpi.target}
                </div>

                <p className="text-sm text-gray-600">
                  {kpi.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-3xl p-12 text-white text-center shadow-2xl">
          <div className="flex items-center justify-center gap-3 mb-6">
            <i className="ri-trophy-line text-5xl text-[#D4AF37]"></i>
          </div>
          <h3 className="text-3xl font-bold mb-4">
            التزامنا بالتميز والجودة
          </h3>
          <p className="text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
            نعمل على تحقيق أعلى معايير الجودة في جميع مراحل الملتقى، من التخطيط إلى التنفيذ والمتابعة، لضمان تحقيق أثر مستدام يخدم الشباب والمجتمع
          </p>
        </div>
      </div>
    </section>
  );
}